/**
 * The screen savers, and how long the machine waits before running one.
 *
 * Adding one means writing a `SaverDraw` in `src/screensaver/savers.ts` and
 * naming it here; nothing else changes.
 */

export type ScreenSaverId = 'none' | 'logo' | 'starfield' | 'mystify' | 'marquee';

export interface ScreenSaverInfo {
  id: ScreenSaverId;
  /** As it appears in the Display Properties list. */
  name: string;
}

export const screenSavers: ScreenSaverInfo[] = [
  { id: 'none', name: '(None)' },
  { id: 'logo', name: 'Windows XP' },
  { id: 'starfield', name: 'Starfield' },
  { id: 'mystify', name: 'Mystify' },
  { id: 'marquee', name: 'Marquee' },
];

/** XP's own default, and the wait it shipped with. */
export const DEFAULT_SCREEN_SAVER: ScreenSaverId = 'logo';
export const DEFAULT_WAIT_MINUTES = 10;

/** The waits the drop-down offers. One minute is here so it can be tried. */
export const WAIT_CHOICES = [1, 2, 3, 5, 10, 15, 20, 30, 60] as const;

export function findScreenSaver(id: string): ScreenSaverInfo {
  return screenSavers.find((s) => s.id === id) ?? screenSavers[0];
}

export function isScreenSaverId(value: unknown): value is ScreenSaverId {
  return typeof value === 'string' && screenSavers.some((s) => s.id === value);
}
